import React, { ReactNode, useEffect, useState } from 'react';
import { ISiteConfig } from '~domain/entities/ISiteConfig';

function WithStyles(props: { children: ReactNode }) {
    const [isStyleSheetLoaded, setIsStyleSheetLoaded] = useState(false);

    useEffect(() => {
        const loyaltyConfig = (window?.site as ISiteConfig)?.loyaltyConfig?.loyalty;

        const loadStyles = async () => {
            try {
                await import(`../../styles/${loyaltyConfig?.brandName.toLowerCase()}.css`);
            } catch (error) {
                console.error(`Failed to load stylesheet for brand "${loyaltyConfig?.brandName}":`, error);
            } finally {
                setIsStyleSheetLoaded(true);
            }
        };

        loadStyles();
    }, []);

    if (!isStyleSheetLoaded) {
        return null;
    }

    return <>{props.children}</>;
}

export default WithStyles;
